import React, { useEffect, useState } from 'react';
import Carousel from '../../Components/home/Carousel/Carousel'
import About from '../../Components/home/About/About';
import DiscountProducts from '../../Components/home/DiscountProducts/DiscountProducts';
import NewProducts from '../../Components/home/NewProducts/NewProducts';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import Categories from '../../Components/home/Categories/Categories';
import BestsellerProducts from '../../Components/home/BestsellerProducts/BestsellerProducts';
import Subscribe from '../../Components/home/Subscribe/Subscribe';



const Home = () => { 


  const { t, i18n } = useTranslation();
   const [showModal, setShowModal] = useState(false);
  
          const currentLanguage = i18n.language; // Aktif dili alıyoruz
        const [single, setSingle] = useState(null);

  useEffect(() => {
        const getSeoTags = async () => {
          try {
            const response = await axios.get('https://www.elzabeauty.az/elza/seoTagsHome.php');
            const data = response.data.data || [];
            setSingle(data[0]);
          } catch (error) { 
            console.error("Error fetching products:", error);
          }
        };
        
        getSeoTags();
        }, []);
                const closeModal = () => {
          setShowModal(false); 
        };
      
        useEffect(() => {
          const timer = setTimeout(() => {
            setShowModal(true);
          }, 5000); // 5 saniye sonra modal göster
      
          return () => clearTimeout(timer); // Sayfa değişirse veya bileşen unmount olursa timer temizlensin
        }, []);
        
  
        
                 const getLocalizedField = (item, fieldBase) => {
                  if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase];
                  if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase];
                  return item[fieldBase]; // default: az
                };

  return ( 
    <> 
     {single && (
  <Helmet>
    <title>{getLocalizedField(single, "meta_tag_title")}</title>
    <meta name="description" content={getLocalizedField(single, "meta_tag_description")} />
    <meta name="keywords" content={getLocalizedField(single, "meta_tag_keywords")} />
  </Helmet>
)}
   <div>
   <Carousel/>
    <Categories/>
    <NewProducts/>
    <About/>
    <DiscountProducts/>  
    <BestsellerProducts/> 
    <Subscribe/>
     {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="relative bg-[white] rounded-[20px] py-[32px] md:py-[53px] px-[19px] md:px-[60px] w-[343px] md:w-[646px] shadow-lg">
              {/* Close Button */}
              <button
                onClick={closeModal}
                className="absolute top-2 right-4 text-gray-500 hover:text-black text-[30px]"
              >
                &times;
              </button>

              <h2 className="text-[18px] font-bold text-firstColor text-center">
                {" "}
                {t("Kampaniyadan Yararlanmaq Şansı!")}
              </h2>
              <p className="mt-6 text-firstColor text-center text-[14px] md:text-[16px]">
                {t(
                  "Sənin üçün xüsusi təklifimiz var! Bu fürsəti qaçırmamaq üçün indi müraciət et və kampaniyanın üstünlüklərindən yararlan."
                )}
              </p>
               <div className="flex justify-center mt-[20px] md:mt-[30px]">
                                    <a
                                      className="w-full md:w-[209px]"
                                      href={`/${currentLanguage}/kampaniya`}
                                    >
                                      <div className="flex items-center justify-center bg-[#181D27] h-[52px] text-white rounded-lg w-full md:w-[209px] transition-all duration-300 ease-in-out transform hover:scale-105 shadow-md hover:shadow-xl">
                                        <div className="flex items-center justify-center">
                                          <div>{t("Ətraflı")}</div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
            </div>
          </div>
        )}
   </div>

    
    </>
  )
}

export default Home;
